/** Fallback wording of the two fixed-wording policy dialogs (U+FB01 "fi" ligatures are in the Angular source, verbatim). */
export const CAPITALISATION_FALLBACK =
  'Where a small entity adopts a policy of capitalising borrowing costs, the inclusion of interest in determining the cost of the asset and the amount of the interest so included is disclosed in a note to the ﬁnancial statements.';

export const FINANCIAL_FALLBACK =
  'The signiﬁcant assumptions underlying the valuation models and techniques used to determine the fair values.';
